import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import esLocale from 'i18n-iso-countries/langs/es.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import itLocale from 'i18n-iso-countries/langs/it.json';
import ptLocale from 'i18n-iso-countries/langs/pt.json';
import caLocale from 'i18n-iso-countries/langs/ca.json';
import deLocale from 'i18n-iso-countries/langs/de.json';
import trLocale from 'i18n-iso-countries/langs/tr.json';
import Cookies from 'js-cookie';

let localesRegistered = false;

function registerLocales() {
  if (localesRegistered) return;
  countries.registerLocale(esLocale);
  countries.registerLocale(enLocale);
  countries.registerLocale(frLocale);
  countries.registerLocale(itLocale);
  countries.registerLocale(ptLocale);
  countries.registerLocale(caLocale);
  countries.registerLocale(deLocale);
  countries.registerLocale(trLocale);
  localesRegistered = true;
}

export function getCountryOptions(lang = Cookies.get('lang')) {
  registerLocales();
  return Object.entries(countries.getNames(lang))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .reduce((sorted, [code, name]) => {
      sorted[code] = name;
      return sorted;
    }, {});
}
